<style>
.center {
  margin: 20px 0 0 20px;
}

</style>

<template>
  <ut-form :label-width="200">
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> API名称：
      </template>
      <ut-input placeholder="请填写API名称：" v-model="apiName" :style="{width:'500px'}"> 
           <template slot='addonAfter'>样例:相机业务-滤镜服务-风格转换接口</template>
      </ut-input>

      <ut-alert type='warn' :style="{width:'500px'}">
        MetricKey埋点目标API的文字描述，用于仪表盘中图片标题展示。可不填，取MetricKey的值作为默认值。
      </ut-alert>

    </ut-form-item>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> MetricKey：
      </template>
      <ut-input placeholder="请填写MetricKey" v-model="metricKey" :style="{width:'500px'}">
        <template slot='addonAfter'>样例:com.apus.microservice.ace.filter.style</template>
      </ut-input>
    </ut-form-item>
     <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> Metric类型：
      </template>
        <ut-select v-model="selected1" clearable :style="{width:'500px'}">
          <ut-option v-for="item in levelOptions" :value="item.value" :key="item.value" :label="item.label"></ut-option>
        </ut-select>
        <ut-alert type='warn' :style="{width:'500px'}">
        MetricKey指的是业务方法上报耗时的Key,假设使用@SimpleMetric埋点,MetricKey就是注解中传入的Key;假设使用ArgusReporter上报业务异常,MetricKey就是reportTime或reportCount方法传入的第一个参数!
        </ut-alert>
      </ut-form-item>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 所属应用：
      </template>
      <ut-select v-model="selected2" filterable clearable	:style="{width:'500px'}" :filter-method='filter'>
          <ut-option v-for="item in appSearchOptions||appOptions" :value="item.appId" :key="item.appId" :label="item.appId" ></ut-option>
      </ut-select>
    </ut-form-item>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> ErrorMetricKey：
      </template>
      <ut-input placeholder="请填写ErrorMetricKey" v-model="errorMetricKey" :style="{width:'500px'}">
        <template slot='addonAfter'>样例:com.apus.microservice.ace.filter.style.error</template>
      </ut-input>
      <ut-alert type='warn' :style="{width:'500px'}">
      ErrorMetricKey指的是业务方法错误次数上报的Key。 可不填,默认值为MetricKey+'.error'。如:MetricKey=a.b.c.d,那么ErrorMetricKey=a.b.c.d.error
      </ut-alert>
    </ut-form-item>
    <ut-form-item>
      <ut-button type="primary" @click="submit">立即创建</ut-button>
      <ut-button @click="goBack">取消</ut-button>
    </ut-form-item>
  </ut-form>
</template>

<script lang="babel">
export default {
  data() {
    return {
        selected1:'',
        selected2:'',
        apiName:'',
        metricKey:'',
        errorMetricKey:'',
        appOptions: [],
        appSearchOptions: null,
        levelOptions: [
        {
          value: "0",
          label: "time"
        },
        {
          value: "1",
          label: "count"
        }
      ],
    }
  },
  methods:{
    filter (val) {
      const data = []
      this.appOptions.map(item => {
          if (item.appId.toLowerCase().indexOf(val) !== -1 || item.appName.toLowerCase().indexOf(val) !== -1) {
            data.push(item)
          }
      })
      if (data.length) {
        this.appSearchOptions = data;
      } else {
        this.appSearchOptions = [];
      }
    },
    submit(){
      var apiName = this.apiName;
      var metricType = this.selected1;
      var appId = this.selected2;
      var metricKey = this.metricKey;
      var errorMetricKey = this.errorMetricKey;
      if(apiName == ''){
        this.$message.error('apiName不能为空');
        return false;
      }
      if(errorMetricKey == ''){
        this.$message.error('errorMetricKey不能为空');
        return false;
      }
      if(metricKey == ''){
        this.$message.error('metricKey不能为空');
        return false;
      }
      if(appId == ''){
        this.$message.error('appId不能为空');
        return false;
      }
      if(metricType == ''){
        this.$message.error('metricType不能为空');
        return false;
      }
      
      var sendData = {};
      sendData.apiName = apiName;
      sendData.metricType = metricType;
      sendData.appId = appId;
      sendData.metricKey = metricKey;
      sendData.errorMetricKey = errorMetricKey;
    

      this.$http({
        method: "post",
        url: "/dashboard/add.htm",
        data: JSON.stringify(sendData)
      })
        .then(response => {
          //这里使用了ES6的语法
          console.log(response); //请求成功返回的数据
          if(response.data.code == 0){
            this.$message.success('添加成功');
            this.$router.push({ path: "/dashboard" });
          }else{
            this.$message.error(response.data.message);
            return false;
          }
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });


    },
    goBack(){
      this.$router.push({ path: "/dashboard" });
    }
  },
  created(){
    this.$http({
        method: "post",
        url: "apps/list.htm",
        data: "{}"
      })
      .then(response => {
        //这里使用了ES6的语法
        console.log(response.data.length); //请求成功返回的数据
        this.appOptions = response.data;
      })
      .catch(error => {
        console.log(error); //请求失败返回的数据
      });
  }
}
</script>